import { AdminUsersRole } from 'stores/users/types';

export const availableRoles: AdminUsersRole[] = ['super-admin', 'admin'];
export const POINTS_TABLE_LIMIT = 100;
// Default value to stop server-side processing
export const DEFAULT_SERVER_VALUE = 0;
